import { render, staticRenderFns } from "./FormForgot.vue?vue&type=template&id=2652ef97&"
import script from "./FormForgot.vue?vue&type=script&lang=js&"
export * from "./FormForgot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports